import { createFileRoute, Navigate } from '@tanstack/react-router';
import { getTargetSelectionData } from '@/features/operation-package/-components/SelectTargetFlow/-store/session-storage';

/**
 * レガシー URL。SelectTargetFlow 統合後は person-targets へリダイレクトする。
 */
export const Route = createFileRoute('/_staff/it-operation-core/_root/in-house-packages/$packageId/start-targets')({
  component: RouteComponent
});
function RouteComponent() {
  const {
    packageId
  } = Route.useParams();
  const session = getTargetSelectionData();
  if (!session?.packageId || !session.patternId) {
    return <Navigate to="/it-operation-core/in-house-packages/$packageId" params={{
      packageId
    }} />;
  }
  return <Navigate to="/it-operation-core/person-targets" />;
}